var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoseGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3496 8.20941L9.96191 5.88006",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5923 8.20941L35.9799 5.88006",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2358 15.9464L42.6392 14.6015",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31746 15.9464L1.91406 14.6015",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4502 3.21273V0.522958",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2607 14.3079C17.8093 12.5822 20.0819 11.4824 22.6254 11.4556C25.3936 11.4265 27.8657 12.6729 29.4503 14.6333",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9276 36.5626L43.7436 41.4378H1.42041L4.88952 36.5626H39.9276Z",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37012 33.9085C5.37012 24.7417 13.0382 17.3085 22.4978 17.3085C31.9574 17.3085 39.6255 24.7417 39.6255 33.9085H5.37012Z",
    stroke: "#151F27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31934 32.1194C9.31934 25.3037 15.2871 19.777 22.6491 19.777C30.011 19.777 35.9788 25.3037 35.9788 32.1194H9.31934Z",
    fill: "url(#paint0_linear_16177_3044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16177_3044",
    x1: 9.31934,
    y1: 19.1092,
    x2: 37.2458,
    y2: 22.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoseGradient);
export default __webpack_public_path__ + "static/media/rose-gradient.34bf8e717bdbd0bfa7ce813cf3e9ef3f.svg";
export { ForwardRef as ReactComponent };